// Implemented for MLM Landing Banner.
const bfAnchorLinks = document.querySelectorAll('[data-scroll-too]');

if (bfAnchorLinks) {
  const stickyHeader = document.querySelector('[data-sticky-type="always"]');

  bfAnchorLinks.forEach(elem => {
    elem.addEventListener('click', event => {
      event.preventDefault();
      const target = document.querySelector(`${elem.dataset.scrollToo}`);

      if (!target) return;

      const scrollConfig = {
        behavior: 'smooth'
      }

      if (!stickyHeader) {
        window.scrollTo(scrollConfig);

        return;
      }

      const headerHeight = stickyHeader.offsetHeight;
      const elementPosition = target.getBoundingClientRect().top + window.scrollY;

      scrollConfig.top = elementPosition - headerHeight;
      window.scrollTo(scrollConfig);
    });
  })
}
